

export function extendWidth(item:JQuery){
    const currentWidth = $(item).width();
    if (currentWidth !== undefined && currentWidth > 0){
        $(item).width(currentWidth + 15);
    }
}